import { css } from "@compiled/react";

import { Adg4Button as Button } from "@/components/adg4/button/src/button";
import type { Adg4ButtonProps as ButtonProps } from "@/components/adg4/button/src/button";
import TryIntent from "@/components/try-intent/src/try-intent";
import { useFirePricingPlanCtaEvent } from "@/libraries/design/components/pricing-card/src/pricing-card-cta-click.ts";
import { getEnvironment } from "@/utils/environment";

import { CloudProductKey } from "../constants";

const ctaButtonStyles = css({
    font: "Charlie Text",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "20px",
    height: "auto",
    textDecoration: "none",
    width: "fit-content",
    whiteSpace: "normal",
    paddingBlockStart: "8px",
    paddingBlockEnd: "8px"
});

export type CtaButtonProps = ButtonProps & {
    edition: string | undefined;
    dataProductKey: CloudProductKey;
    text: string;
    type: "primary" | "secondary";
    url: string;
    dataEventPropsLabel: string;
    isDisabled: boolean;
    containerId: string;
};

export const CtaButton = ({
    edition,
    dataProductKey,
    text,
    type,
    url,
    dataEventPropsLabel,
    containerId,
    isDisabled,
    ...props
}: CtaButtonProps) => {
    const fireCtaEvent = useFirePricingPlanCtaEvent({
        edition,
        containerId,
        productKey: dataProductKey
    });

    const envSpecificURL =
        getEnvironment(true) === "staging"
            ? url.replace(
                  /https:\/\/(www.)?atlassian.com/,
                  "https://wac.stg.internal.atlassian.com"
              )
            : url;

    const handleClick = () => {
        fireCtaEvent();
        // @ts-ignore
        props.onClick?.();
    };

    return (
        <TryIntent
            intentType={"button"}
            containerId={containerId}
            productKey={dataProductKey}
            edition={edition}
        >
            <Button
                isDisabled={isDisabled}
                variant={type}
                color="black"
                href={envSpecificURL}
                dataEventProps={{
                    "data-product-key": dataProductKey,
                    "data-event-component": "linkButton",
                    "data-event-container": "priceBlock",
                    "data-event": "clicked",
                    "data-label": `${dataEventPropsLabel}`,
                    "data-label-english": `${dataEventPropsLabel}`
                }}
                css={ctaButtonStyles}
                {...props}
                onClick={handleClick}
            >
                {text}
            </Button>
        </TryIntent>
    );
};
